/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { SurveyQuestionType } from "./SurveyQuestionType";

export class SurveyAnswerInvoiceViewModel {
    surveyQuestionId: string;
    surveyQuestionLabel: string;
    surveyQuestionType: SurveyQuestionType;
    surveyQuestionTypeString: string;
    surveyQuestionParameterName: string;
    surveyQuestionIndex: number;
    surveyQuestionForPro: boolean;
    surveyAnswerId: string;
    answerOrganisationId: string | null;
}
